import { forwardRef, type ComponentProps } from "react"
import { useOpenExternalUrl } from "~/components/providers/DiscordActivity"

export const ActivityExternalLink = forwardRef<
	HTMLAnchorElement,
	ComponentProps<"a"> & { href: string }
>(function ActivityExternalLink(
	{ href, onClick, target = "_blank", rel = "noreferrer", ...props },
	ref
) {
	const openExternalUrl = useOpenExternalUrl()

	return (
		<a
			ref={ref}
			href={href}
			target={target}
			rel={rel}
			onClick={(event) => {
				onClick?.(event)
				if (event.defaultPrevented) return
				const url = new URL(href, window.location.origin)
				if (url.origin === window.location.origin) return
				event.preventDefault()
				openExternalUrl(url.toString())
			}}
			{...props}
		/>
	)
})
